import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Request from './Request/Request/Request';
import { RequestProvider } from './Request/Request.Context';
import SearchRequest from './SearchRequest/SearchRequest';
import { useDataValidations } from '../shared/hooks/useDataValidations';
import { useCurrentUserProfile } from './User/userSlice';
import { useRecaptcha } from '../shared/google-recaptcha-v3/useRecaptcha';
import { t } from 'i18next';
import { RootStore, useAppDispatch, useAppSelector } from '../shared/redux/store';
import ConsultRequest from './Simulation/Simulation';

const equivalencyRequestPath = t('equivalencyRequestPath');
const equivalencyConsultPath = t('equivalencyConsultPath');
const equivalencySearchPath = t('equivalencySearchPath');

export const equivalencyRequestNavigation = {
  equivalency: () => `/${equivalencyRequestPath}`,
  consultEquivalency: () => `/${equivalencyConsultPath}`,
  searchEquivalency: (params: string) => `/${equivalencySearchPath}${params}`
};

const AppRoutes = () => {
  const settings = useAppSelector((state) => state.settings);
  return (
    <Routes>
      <Route key={equivalencyConsultPath} path={equivalencyConsultPath} element={<ConsultRequest />} />
      <Route key={equivalencyRequestPath} path={equivalencyRequestPath} element={
        <RequestProvider
          location={useLocation()}
          validations={useDataValidations()}
          studentRecord={useCurrentUserProfile()}
          studentRequest={useAppSelector((state: RootStore) => state.request.student)}
          dispatch={useAppDispatch()}
          recaptcha={useRecaptcha()}
          settings={settings}
        >
          <Request />
        </RequestProvider>
      }>
      </Route>
      <Route key={equivalencySearchPath} path={`${equivalencySearchPath}/*`} element={<SearchRequest />} />
      <Route key="redirect" path="*" element={<Navigate to={equivalencyRequestNavigation.equivalency()} replace />} />
    </Routes>);
};

export default AppRoutes;
